"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLES = void 0;
exports.ROLES = [
    'owner',
    'member',
    'bookkeeper-basic',
    'bookkeeper-extended',
    'bookkeeper-managed',
];
//# sourceMappingURL=employee-roles.js.map